// Debug:

GW.define('Debug.Screen', 'Main.Screen', {
	title: _('Debugovací panel'),
	titleIcon: 'bug',

	'after:initComponent'() {
		this.el.classList.add('debug-screen');
	},

	getSidebarMenu() {
		return [{
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/state',
			textContent: _('Deep Backend'),
		}, {
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/calls',
			textContent: _('Hovory'),
		}, {
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/scenarios',
			textContent: _('Scénáře'),
		}, {
			nodeName: 'a',
			className: 'item',
			href: APP_BASE + 'debug/loopback',
			textContent: _('Loopback'),
		}];
	},
});

// {{{ Debug.CallsScreen

GW.define('Debug.CallsScreen', 'Debug.Screen', {
	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
			ref: 'calls',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			getColumns() {
				return [{
					id: 'id',
					name: _('Linked ID'),
					formatCell(td, v, row) {
						td.gwCreateChild({
							className: 'id',
							textContent: v,
						});

						td.gwCreateChild({
							className: 'time',
							textContent: Formats.datetime(row.ts),
						});
					},
				}];
			},
			selectable: true,
			onRowClick: async (row, tr, ev) => {
				this.calls.selectRow(r => row === r);

				row.events = await this.getCallEvents(row.id);

				this.renderCall(row);
			},
		}, {
			className: 'detail',
			ref: 'detailCt',
			children: [{
				nodeName: 'canvas',
				ref: 'canvas',
			}, {
				ref: 'labelsOverlayEl',
				className: 'labels',
			}],
		}], this);
	},

	async getCallEvents(id) {
		return await REST.GET('debug/calls/events', {linkedid: id});
	},

	renderCall(call) {
		let start_ts = call.events[0].ts;
		let end_ts = call.events[call.events.length - 1].ts;
		let total_time = end_ts - start_ts;
		let ev_count = call.events.length;

		let channel_props = new Set([
			'Channel',
			'DestChannel',
			'LocalOneChannel',
			'LocalTwoChannel',
			'OrigTransfererChannel',
			'SecondTransfererChannel',
			'SourceChannel',
			'TransfereeChannel',
			'TransfererChannel',
			'TransferTargetChannel',
		]);

		let channels = call.events.reduce((list, e) => {
			for (let [k, v] of Object.entries(e)) {
				if (!e._chans) {
					e._chans = new Set;
				}

				if (channel_props.has(k)) {
					list.add(v);
					e._chans.add(v);
				}
			}
			return list;
		}, new Set);

		let next_color = 0;
		let bridges = {};
		let ch_info = {};
		let max_ch_ev_count = 0;
		for (let ch of channels) {
			let chi = ch_info[ch] = {};

			chi.events = call.events.filter(e => e._chans.has(ch)).map(e => ({...e, ts: e.ts - start_ts}));
			chi.start_ts = chi.events[0].ts;
			chi.end_ts = chi.events[chi.events.length - 1].ts;
			chi.bridge_segs = [];

			max_ch_ev_count = Math.max(max_ch_ev_count, chi.events.length);

			let ch_bridges = {};
			for (let e of chi.events) {
				if (e.Event == 'BridgeEnter') {
					if (!bridges[e.BridgeUniqueid]) {
						bridges[e.BridgeUniqueid] = {
							id: e.BridgeUniqueid,
							color: `hsl(${next_color}, 100%, 50%)`,
						};

						next_color = (next_color + 50) % 360;
					}

					let b = bridges[e.BridgeUniqueid];
					ch_bridges[b.id] = e.ts;
				} else if (e.Event == 'BridgeLeave') {
					let b = bridges[e.BridgeUniqueid];
					if (b) {
						if (ch_bridges[b.id] === undefined) {
							continue;
						}

						chi.bridge_segs.push({
							bridge: bridges[b.id],
							start: ch_bridges[b.id],
							end: e.ts
						});

						delete ch_bridges[b.id];
					}
				}
			}
		}

		let chan_w = 720;

		let w = this.canvas.width = Math.max(chan_w * (channels.size + 0.5), this.detailCt.clientWidth);
		let h = this.canvas.height = Math.max(max_ch_ev_count * 30, this.detailCt.clientHeight - 5);

		this.labelsOverlayEl.style.width = w + 'px';
		this.labelsOverlayEl.style.height = h + 'px';

		let scroll_h = h;

		let c = this.canvas.getContext('2d');

		// clear canvas
		c.fillStyle = '#fff';
		c.fillRect(0, 0, w, h);

		c.fillStyle = '#ccc';
		c.fillRect(0, 0, w, 26);

		// draw channel lines and names

		let labels = [];
		let col = 0;
		for (let ch of channels) {
			let info = ch_info[ch];

			// channel column
			c.save();
			c.translate(col * chan_w, 0);

			// title
			c.save();
			c.fillStyle = 'black';
			c.textBaseline = 'hanging';
			c.font = 'bold 12px sans-serif';
			c.textAlign = 'center';
			c.fillText(ch, chan_w / 2, 10, chan_w);
			c.restore();

			let timeline_pad_top = 40;
			let timeline_pad_bottom = 140;

			// draw channel line
			let y_scale = (scroll_h - timeline_pad_top - timeline_pad_bottom) / total_time;

			let next_avail_y = 0;

			c.save();
			c.translate(0, timeline_pad_top);
			c.fillStyle = '#aac';
			c.fillRect(chan_w / 2 - 15, info.start_ts * y_scale, 30, (info.end_ts - info.start_ts) * y_scale);

			c.fillStyle = '#aac';
			c.fillRect(chan_w / 2, 0, 1, y_scale * total_time);

			for (let ev of info.events) {
				let y = ev.ts * y_scale - 1;

				// event marker
				c.fillStyle = '#88a';
				c.fillRect(chan_w / 2 - 40, y, 80, 2);

				let text_y_space = 13;
				let text_off = 50;
				let text_y = y;
				if (y < next_avail_y) {
					text_y = next_avail_y;
					next_avail_y += text_y_space;
				} else {
					next_avail_y = y + text_y_space;
				}

				let text = ev.Event;
				if (ev.Event == 'CEL') {
					text += ':' + ev.EventName;
				} else if (ev.Event == 'Newexten') {
					text += ':' + ev.Context + ':' + ev.Extension + ':' + ev.Priority + ':' + ev.Application + '(' + ev.AppData + ')';
				} else if (ev.Event == 'NewCallerid') {
					text += ':' + ev.CallerIDNum + ' (' + ev.CallerIDName + ')';
				} else if (ev.Event == 'NewConnectedLine') {
					text += ':' + ev.ConnectedLineNum + ' (' + ev.ConnectedLineName + ')';
				} else if (ev.Event == 'DialBegin') {
					text += ':' + ev.DialString + ' ch=' + ev.DestChannel;
				} else if (ev.Event == 'DialState') {
					text += ':' + ev.DialStatus + ' ch=' + ev.DestChannel;
				} else if (ev.Event == 'DialEnd') {
					text += ':' + ev.DialStatus + ' ch=' + ev.DestChannel;
				} else if (ev.Event == 'Newstate') {
					text += ':' + ev.ChannelStateDesc;
				} else if (ev.Event == 'QueueCallerJoin') {
					text += ':' + ev.Queue + ' pos=' + ev.Position + ' count=' + ev.Count;
				} else if (ev.Event == 'QueueCallerLeave') {
					text += ':' + ev.Queue + ' pos=' + ev.Position + ' count=' + ev.Count;
				} else if (ev.Event == 'AgentCalled') {
					text += ':' + ev.Queue + ' interface=' + ev.Interface + ' member=' + ev.MemberName;
				} else if (ev.Event == 'AgentConnect') {
					text += ':' + ev.Queue + ' interface=' + ev.Interface + ' member=' + ev.MemberName + ' holdtime=' + ev.HoldTime + ' ringtime=' + ev.RingTime;
				} else if (ev.Event == 'DTMFBegin') {
					text += ':' + ev.Direction + ' ' + ev.Digit;
				} else if (ev.Event == 'DTMFEnd') {
					text += ':' + ev.Direction + ' ' + ev.Digit + ' dur=' + ev.DurationMs + 'ms';
				} else if (ev.Event == 'BridgeEnter') {
					text += ':' + ev.BridgeUniqueid;
				} else if (ev.Event == 'BridgeLeave') {
					text += ':' + ev.BridgeUniqueid;
				} else if (ev.Event == 'SoftHangupRequest') {
					text += ':' + 'cause=' + ev.Cause;
				} else if (ev.Event == 'Hangup') {
					text += ':' + 'cause=' + ev['Cause-txt'];
				} else if (ev.Event == 'RTCPSent') {
					text += ':' + ev.PT + ' ' + ev.From + ' -> ' + ev.To + ' lost=' + (ev.Report0CumulativeLost || '') + ' sent=' + (ev.SentPackets || '');
				} else if (ev.Event == 'RTCPReceived') {
					text += ':' + ev.PT + ' ' + ev.From + ' -> ' + ev.To + ' lost=' + (ev.Report0CumulativeLost || '') + ' sent=' + (ev.SentPackets || '');
				}

				// line to event text
				c.save();
				c.strokeStyle = '#aaa';
				c.beginPath();
				c.moveTo(chan_w / 2 + 40, y);
				c.lineTo(chan_w / 2 + 40 + text_off - 3, text_y);
				c.stroke();
				c.restore();

				c.save();
				c.fillStyle = 'black';
				c.textBaseline = 'middle';
				c.font = '12px sans-serif';
				c.textAlign = 'left';
				c.fillText(text, chan_w / 2 + 40 + text_off, text_y);

				// we don't do scaling, so this works
				let t = c.getTransform();
				let m = c.measureText(text);
				labels.push({
					x: t.e + chan_w / 2 + 40 + text_off,
					y: t.f + text_y - 7,
					w: m.width,
					h: 14,
					ev,
					text: JSON.stringify(ev, null, '    '),
				});

				c.restore();
			}

			for (let br_seg of info.bridge_segs) {
				let rect = {
					x: chan_w / 2 - 20,
					y: br_seg.start * y_scale,
					w: 40,
					h: (br_seg.end - br_seg.start) * y_scale,
				};

				c.save();
				c.fillStyle = br_seg.bridge.color;
				c.fillRect(rect.x, rect.y, rect.w, rect.h);
				c.restore();

				// we don't do scaling, so this works
				let t = c.getTransform();
				labels.push({
					x: t.e + rect.x,
					y: t.f + rect.y,
					w: rect.w,
					h: rect.h,
					bridge: br_seg.bridge,
					text: JSON.stringify({
						bridge: br_seg.bridge.id,
					}, null, '    '),
				});
			}

			c.restore();

			c.restore();

			col++;
		}

		this.labelsOverlayEl.gwReplaceChildren(labels.map(l => {
			return {
				className: 'label',
				style: `top: ${l.y}px; left: ${l.x}px; width: ${l.w}px; height: ${l.h}px;`,
				'on:mouseenter': ev => {
					let popup = document.gwCreateElement({
						className: 'debug-popup',
						textContent: l.text,
					});

					PopupManager.show(popup, {
						anchorEl: ev.target,
					});
				},
				'on:mouseleave': ev => {
					PopupManager.hideAll();
				},
				'on:click': ev => {
					alert(l.text);
				},
			};
		}));
	},

	setData(calls) {
		this.calls.setData(calls);
	},
});

// }}}
// {{{ Debug.StateScreen

GW.define('Debug.StateScreen', 'Debug.Screen', {
	renderExtensions() {
		return [{
			nodeName: 'h2',
			textContent: _('Linky'),
		}, {
			ref: 'extensionsTable',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			renderRow(tr, row) {
				tr.dataset.json = JSON.stringify(row, null, '  ');
			},
			getColumns() {
				return [{
					id: 'extension',
					name: _('Linka'),
				}, {
					id: 'available',
					name: _('Stav'),
					formatCell(td, v, row) {
						td.textContent = v ? 'available' : 'unavailable';
						td.dataset.status = v ? 'available' : 'unavailable';
					},
				}, {
					id: 'devices',
					name: _('Zařízení'),
					formatCell(td, v, row) {
						for (let d of v) {
							td.gwCreateChild({
								className: 'device',
								children: [{
									className: 'id',
									textContent: d.endpoint,
								}, {
									className: 'kind',
									textContent: d.kind,
								}, {
									className: 'status',
									textContent: d.reachable ? 'reachable' : 'unreachable',
									'attr:data-status': d.reachable ? 'reachable' : 'unreachable',
								}]
							});
						}
					},
				}];
			},
		}];
	},

	renderChannels() {
		let timeCell = this.timeCell.bind(this);

		return [{
			nodeName: 'h2',
			textContent: _('Kanály'),
		}, {
			ref: 'channelsTable',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			renderRow(tr, row) {
				tr.dataset.json = JSON.stringify(row, null, '  ');
			},
			getColumns() {
				return [{
					id: 'first_time',
					name: _('Vznikl'),
					formatCell: timeCell,
				}, {
					id: 'channel',
					name: _('Kanál'),
				}, {
					id: 'state',
					name: _('Stav'),
					formatCell(td, v, row) {
						td.setAttribute('data-state', v);
						td.textContent = v + (row.hold ? ' hold' : '') + (row.musichold ? ' musichold' : '');
					},
				}, {
					id: 'caller',
					name: _('Volající'),
				}, {
					id: 'connected_line',
					name: _('Spojená linka'),
				}, {
					id: 'queue',
					name: _('Fronta'),
				}, {
					id: 'linked_id',
					name: _('Linked ID'),
				}];
			},
		}];
	},

	renderConnections() {
		let timeCell = this.timeCell.bind(this);

		return [{
			nodeName: 'h2',
			textContent: _('Spojení'),
		}, {
			ref: 'connectionsTable',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			renderRow(tr, row) {
				tr.dataset.json = JSON.stringify(row, null, '  ');
			},
			getColumns() {
				return [{
					id: 'dial_ts',
					name: _('Vytáčení'),
					formatCell: timeCell,
				}, {
					id: 'ring_ts',
					name: _('Vyzvánění'),
					formatCell: timeCell,
				}, {
					id: 'start_ts',
					name: _('Hovor začal'),
					formatCell: timeCell,
				}, {
					id: 'external',
					name: _('Druh'),
				}, {
					id: 'caller',
					name: _('Volající'),
					formatCell(td, v, row) {
						td.gwReplaceChildren([{
							nodeName: 'span',
							className: 'name',
							textContent: v,
						}, ' - ', {
							nodeName: 'span',
							className: 'channel',
							textContent: row.channel_caller ? row.channel_caller.channel : '',
						}, ' - ', {
							nodeName: 'span',
							className: 'state',
							'attr:data-state': row.channel_caller ? row.channel_caller.state : '',
							textContent: row.channel_caller ? row.channel_caller.state : '',
						}]);
					},
				}, {
					id: 'callee',
					name: _('Volaný'),
					formatCell(td, v, row) {
						td.gwReplaceChildren([{
							nodeName: 'span',
							className: 'name',
							textContent: v,
						}, ' - ', {
							nodeName: 'span',
							className: 'channel',
							textContent: row.channel_callee ? row.channel_callee.channel : '',
						}, ' - ', {
							nodeName: 'span',
							className: 'state',
							'attr:data-state': row.channel_callee ? row.channel_callee.state : '',
							textContent: row.channel_callee ? row.channel_callee.state : '',
						}]);
					},
				}, {
					id: 'queue',
					name: _('Fronta'),
				}];
			},
		}];
	},

	renderQueues() {
		return [{
			nodeName: 'h2',
			textContent: _('Fronty'),
		}, {
			ref: 'queuesTable',
			xtype: 'SmartTable',
			emptyText: _('Nic'),
			renderRow(tr, row) {
				tr.dataset.json = JSON.stringify(row, null, '  ');
			},
			getColumns() {
				return [{
					id: 'queue',
					name: _('Fronta'),
				}, {
					id: 'agents',
					name: _('Agenti'),
					formatCell(td, v, row) {
						for (let a of v) {
							td.gwCreateChild({
								className: 'agent',
								children: [{
									className: 'exten',
									textContent: a.exten,
								}, {
									className: 'interface',
									textContent: a.interface,
								}, {
									className: 'paused',
									textContent: a.paused ? 'paused' : '',
								}]
							});
						}
					},
				}];
			},
		}];
	},

	timeCell(td, v) {
		td.textContent = this.formatTime(v);
	},

	formatTime(ts) {
		if (ts == null) {
			return '';
		}

		if (!(ts instanceof Date)) {
			ts = new Date(ts);
		}

		return this.timeFmt.format(ts) + '.' + ts.getMilliseconds();
	},

	'after:initComponent'() {
		this.el.classList.add('js-msgbus');
		this.el.socketSubscriptions = ['debug'];

		this.timeFmt = new Intl.DateTimeFormat('cs-CZ', {
			year: 'numeric', month: 'numeric', day: 'numeric',
			hour: 'numeric', minute: 'numeric', second: 'numeric',
		});

		this.bodyEl.gwReplaceChildren([{
			className: 'toolbar',
			children: [{
				nodeName: 'button',
				className: 'primary',
				textContent: _('Obnovit data'),
				'on:click': ev => this.reload(),
			}],
		}, {
			className: 'detail',
			ref: 'detailCt',
			'on*:mouseenter': ev => {
				let el = ev.target.closest('[data-json]');
				if (el) {
					PopupManager.hideAll();

					let popup = document.gwCreateElement({
						className: 'debug-json-popup',
						textContent: el.getAttribute('data-json'),
					});

					PopupManager.show(popup, {
						anchorEl: ev.target,
					});
				}
			},
			'on*:mouseleave': ev => {
				PopupManager.hideAll();
			},
			'on*:click': ev => {
				let el = ev.target.closest('[data-json]');
				if (el) {
					alert(el.getAttribute('data-json'));
				}
			},
			children: [
				...this.renderChannels(),
				...this.renderConnections(),
				...this.renderExtensions(),
				...this.renderQueues(),
			],
		}], this);
	},

	onBusMessage(msg) {
		if (msg.type == 'DBC_STATE_CHANGED') {
			Utils.dedupeCalls(this, 'reload', 500, () => this.reload());
		}
	},

	async reload() {
		let signal = Utils.abortAndRetry(this, 'reload');
		let state = await REST.GET('debug/state', null, {signal});

		this.extensionsTable.setData(state.extensions);
		this.connectionsTable.setData(state.connections);
		this.channelsTable.setData(state.channels);
		this.queuesTable.setData(state.queues);
	},
});

// }}}
// {{{ Debug.LoopbackScreen

GW.define('Debug.LoopbackScreen', 'Debug.Screen', {
	'after:initComponent'() {
		this.el.classList.add('js-msgbus');
		this.el.socketSubscriptions = ['debug'];

		this.bodyEl.gwReplaceChildren([{
			nodeName: 'h2',
			textContent: _('Log události z POST /api/debug/loopback'),
		}, {
			ref: 'listCt',
			className: 'event-list',
		}], this);
	},

	renderMessage(body) {
		this.listCt.gwCreateChild({
			className: 'event',
			textContent: Formats.datetime(Date.now() / 1000) + ':\n' + JSON.stringify(body, null, '    '),
		});
	},

	onBusMessage(msg) {
		if (msg.type == 'DEBUG_LOOPBACK') {
			this.renderMessage(msg.body);
		}
	},
});

// }}}

// {{{ Routes

if (env.DEBUG) {
	Application.addRoutes([{
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/calls',
		async handler({params, captures}) {
			let c = Application.show({
				id: 'debug.calls',
				xtype: 'Debug.CallsScreen',
			});

			c.setData(await REST.GET('debug/calls'));
		}    
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/scenarios',
		async handler({params, captures}) {
			let c = Application.show({
				id: 'debug.scenarios',
				xtype: 'Debug.CallsScreen',
				async getCallEvents(id) {
					return await REST.GET('debug/scenarios/events', {id});
				},
			});

			c.setData(await REST.GET('debug/scenarios'));
		}    
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/ami',
		async handler({params, captures}) {
			let c = Application.show({
				xtype: 'Debug.LogScreen',
			});

			c.reload();
		}    
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/state',
		async handler({params, captures}) {
			let c = Application.show({
				xtype: 'Debug.StateScreen',
			});

			c.reload();
		}    
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug/loopback',
		async handler({params, captures}) {
			let c = Application.show({
				xtype: 'Debug.LoopbackScreen',
			});
		}    
	}, {
		group: 'auth',
		module: 'debug',
		path: APP_BASE + 'debug',
		async handler({params, captures}) {
			Application.replaceRoute(APP_BASE + 'debug/state');
		}    
	}]);

	Application.registerModule({
		id: 'debug',
		title: _('Debugovací panel'),
		tagline: _('Ladění systému'),
		icon: 'bug',
		href: APP_BASE + 'debug',
	});
}

// }}}
